/*
================================================================ 
          Copyright (c) 2018-2021 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

const PdfViewer = ({ base64PdfDocument }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div>
      <Document
        file={base64PdfDocument}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={(error) => console.error("PDF load error:", error)}
        options={{
          cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
          cMapPacked: true,
        }}
      >
        <Page pageNumber={pageNumber} renderTextLayer renderAnnotationLayer />
      </Document>

      <p style={{ marginTop: "8px" }}>
        Page {pageNumber} of {numPages || "--"}
      </p>
    </div>
  );
};

export default PdfViewer;
